"use strict";
/*!
 *
 *  menu.ts
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.menu = function () {
    var $header = $('#header');
    var $menu = $('#menu');
    var $btn = $menu.children('.l_menu_btn').children('a');
    var $body = $('#menuBody');
    var $localBtn = $('.common_local_btn a');
    var $localFixed = $('#localFixed');
    $btn.on('click', function (e) {
        e.preventDefault();
        $menu.toggleClass('-expanded');
        $header.toggleClass('-menu-open');
        $body.stop(false, true).animate({
            height: 'toggle'
        }, 500, 'easeOutQuart');
    });
    $(document).on('click', function (e) {
        if (util.viewport !== 'desktop' && util.viewport !== 'largeDesktop' && !$(e.target).closest('#menu').length) {
            if ($menu.is('.-expanded')) {
                $menu.removeClass('-expanded');
                $header.removeClass('-menu-open');
                $body.stop(false, true).animate({
                    height: 'hide'
                }, 500, 'easeOutQuart');
            }
            ;
        }
        ;
    });
    $(window).on('viewportChanged', function () {
        if (util.viewport === 'desktop') {
            $menu.removeClass('-expanded');
            $header.removeClass('-menu-open');
            $body.removeAttr('style');
        }
        ;
    });
    if ($localFixed.length) {
        $localBtn.on('click', function (e) {
            e.preventDefault();
            $localFixed.toggleClass('-open');
        });
        $(document).on('click', function (e) {
            if (util.viewport !== 'desktop' && util.viewport !== 'largeDesktop' && util.viewport !== 'tablet' && $localFixed.is('.-open')) {
                if (!$(e.target).closest($localFixed).length && !$(e.target).closest($('.common_local_btn')).length) {
                    $localFixed.removeClass('-open');
                }
                ;
            }
            ;
        });
    }
    ;
};
exports.megamenu = function () {
    var $wrapper = $('#wrapper');
    // const $menu = $('#megamenuBusiness');
    // const $a = $menu.prev('a');
    // const $li = $menu.closest('li');
    var $li = $('.l_global_item.-megamenu');
    var $a = $li.children('a');
    $a.on('click', function (e) {
        e.preventDefault();
        var menuOpen = function () {
            $(e.currentTarget).toggleClass('-open');
            $(e.currentTarget).next('.l_megamenu').stop(false, true).animate({
                height: 'toggle'
            }, 700, 'easeOutQuart');
        };
        if ($wrapper.is('.-overlay') && !$(e.currentTarget).is('.-open')) {
            var $current = $a.filter(function (i, elem) {
                return $(elem).is('.-open');
            });
            $current.removeClass('-open');
            $current.next('.l_megamenu').stop(false, true).animate({
                height: 'hide'
            }, 300, 'easeOutQuart', function () {
                menuOpen();
            });
        }
        else {
            $wrapper.toggleClass('-overlay');
            menuOpen();
        }
        ;
    });
    $(document).on('click', function (e) {
        if (!$(e.target).closest('.l_global_item.-megamenu').length) {
            if ($wrapper.is('.-overlay')) {
                var $current = $a.filter(function (i, elem) {
                    return $(elem).is('.-open');
                });
                $current.removeClass('-open');
                $wrapper.removeClass('-overlay');
                $current.next('.l_megamenu').stop(false, true).animate({
                    height: 'hide'
                }, 700, 'easeOutQuart');
            }
            ;
        }
        ;
    });
    var $titleBtn = $('.l_megamenu_list_title_btn');
    $titleBtn.on('click', function (e) {
        var $body = $(e.currentTarget).closest('.l_megamenu_list_title').next('.l_megamenu_list_body');
        var $current = $titleBtn.filter(function () {
            return $(this).is('.-open') && !$(this).is(e.currentTarget);
        });
        if ($current.length) {
            var $currentBody = $current.closest('.l_megamenu_list_title').next('.l_megamenu_list_body');
            $current.removeClass('-open');
            $currentBody.stop(false, true).animate({
                height: 'hide'
            }, 700, 'easeOutQuart');
        }
        ;
        $(e.currentTarget).toggleClass('-open');
        $body.stop(false, true).animate({
            height: 'toggle'
        }, 700, 'easeOutQuart');
    });
    $(window).on('viewportChanged', function () {
        if (util.viewport === 'desktop') {
            $titleBtn.removeClass('-open');
            $('.l_megamenu_list_body').removeAttr('style');
        }
        ;
    });
};
